export default __webpack_public_path__ + "static/media/ruhackslogo.a5689cb4.png";